import { AuthMap } from '@/constant/index';

import { i18n } from '@/i18n';
const { t } = i18n.global;
/**
 * 因为国际化需要动态生成
 * @returns 菜单数据
 */
function makeUpMenuData() {
  return {
    org: [
      {
        // 资源中心
        id: 'resourceCenter',
        label: t('enterprise.resourceCenter'),
        permission: 'maintainer'
      },
      {
        id: 'enterpriseSetting',
        label: t('enterprise.setup'),
        permission: 'visitor'
      }
    ],
    enterpriseSetting: [
      // 组织与成员
      // 1 企业信息
      // 2 企业成员管理
      // 3 角色与权限
      // 4 组织管理
      // 5 我的企业信息(暂时放这里 后续改为点击头像进入)

      // 基础设施
      // 1、企业webHooks
      // 2、默认设置

      // 运营配置
      // 1、Issue字段配置
      {
        id: 'enterpriseDetail',
        label: t('enterprise.infoSetting'),
        menuType: t('orgSetting.userManage'),
        permission: 'visitor',
        icon: 'gt-line-introduce'
      },
      {
        id: 'enterpriseSettingMember',
        label: t('enterprise.memberManage'),
        menuType: t('orgSetting.userManage'),
        permission: 'maintainer',
        icon: 'gt-line-users'
      },
      {
        id: 'enterpriseSettingRolesPermission',
        label: t('enterprise.rolePermissions'),
        menuType: t('orgSetting.userManage'),
        permission: 'maintainer',
        icon: 'gt-line-authority'
      },
      {
        id: 'enterpriseSettingOrganization',
        label: t('userSetting.menu.orgManage'),
        permission: 'admin',
        menuType: t('orgSetting.userManage'),
        icon: 'gt-line-organization'
      },
      {
        id: 'enterpriseSettingAliasSetting',
        label: t('enterprise.infoSettingTitle'),
        menuType: t('orgSetting.userManage'),
        permission: 'visitor',
        icon: 'gt-line-user'
      },
      {
        id: 'enterpriseSettingDefault',
        label: t('orgSetting.defaultSetting.title'),
        permission: 'maintainer',
        menuType: t('repoSetting.basic.basicSetting'),
        icon: 'gt-line-advancedSearch'
      },
      {
        id: 'enterpriseSettingWebhook',
        label: 'WebHook',
        permission: 'maintainer',
        menuType: t('repoSetting.basic.basicSetting'),
        icon: 'gt-line-webhook'
      },
      {
        id: 'enterpriseSettingIssues',
        label: t('orgSetting.issue.title'),
        permission: 'maintainer',
        menuType: t('repoSetting.basic.operationSetting'),
        icon: 'gt-line-issues'
      },
      {
        id: 'enterpriseSettingEnterpriseLabels',
        label: `${t('profile.dynamic.actionTarget.enterprise')} Label`,
        permission: 'maintainer',
        menuType: t('repoSetting.basic.operationSetting'),
        icon: 'gt-line-tag'
      },
      {
        id: 'enterpriseApps',
        label: 'AtomGit Apps',
        permission: 'admin',
        menuType: t('repoSetting.basic.operationSetting'),
        icon: 'gt-line-application'
      }
    ],
    resourceCenter: [
      {
        id: 'enterpriseSettingMilestone',
        label: t('orgSetting.milestone.title'),
        permission: 'maintainer',
        menuType: t('enterprise.resourceCenter'),
        icon: 'gt-line-milestone'
      },
      {
        id: 'enterpriseIssueList',
        label: t('repoSetting.basic.enterpriseIssueList'),
        permission: 'admin',
        enterpriseAuthority: AuthMap.issue.update, // 特殊企业权限。
        menuType: t('enterprise.resourceCenter'),
        icon: 'gt-line-list'
      }
    ]
  };
}
export default makeUpMenuData;
